
export default {
    namespaced: true,

    state: {
        agentes: [],
        agentesDisp: []
    },
    getters: {
        getAgentes(state){ //take parameter state
            return state.agentes
        },
        getAgentesEstados: (state) => (estados) =>{
            return state.agentes.filter(age => estados.includes(age.abrev))
        },
        agentesDisponibles: state => {
            return state.agentesDisp
        }
        // nuevosMensajes: (state) => (id_inter_global) => {
        //     return state.nuevos_mensajes.find(mensajes => mensajes.id_inter_global === id_inter_global)
        // }
    },
    actions: {
        consultaAgente({commit},data){
            return new Promise((resolve, reject) => {
                axios.post('agentesConectados',{idAgente: data === undefined ? null : data.id})
                    .then(response => {
                        const dataAgente = response.data.agentes
                        const info = {
                            dataAgente: dataAgente,
                            data: data
                        }
                        commit('setAgente',info)
                        resolve()

                    })
                    .catch(error =>{
                        const info = {
                            dataAgente: [],
                            data: data
                        }
                        commit('setAgente',info)
                        resolve()
                    })
            })
        },
        cerrarSesion({commit},data) {
            return new Promise((resolve, reject) => {
                axios.post('cerrarSesion',{agenteId: data})
                    .then(response => {
                        if(response.data.resultado === true){
                            commit('logoutAgente',data)
                        }

                        resolve()
                    })
                    .catch(error =>{
                        // commit('setAgente',[])
                        resolve()
                    })
            })
        },
        buscarAgentes({commit},data) {
            return new Promise((resolve, reject) => {
                axios.get(`agentesConectadosWeb?id_inter_global=${data.id_inter_global}`)
                    .then(response => {
                        if (response.data.resultado) {
                            commit('SET_AGENTES', response.data.message)
                            resolve()
                        } else {
                            const error = {
                                message: response.data.message,
                                response: {
                                    status: 200
                                }
                            }
                            commit('SET_AGENTES',[])
                            // this.$obtenerError(error)
                            reject(error)
                        }
                    }).catch(error => {
                    reject(error)

                    // reject(this.$obtenerError(error, false).message)
                })
            })
        }
    },
    mutations: {
        setAgente(state,info) {
            if(info.data === undefined){
                state.agentes = info.dataAgente
            }else{
                if(info.dataAgente.length !== 0){
                    const existe = state.agentes.findIndex(age => parseInt(age.id) === parseInt(info.dataAgente[0].id))
                    if(existe === -1){
                        state.agentes.push(info.dataAgente[0])
                    }
                }else{
                    const existe = state.agentes.findIndex(age => parseInt(age.id) === parseInt(info.data.id))
                    if(existe !== -1){
                        state.agentes.splice(existe,1)
                    }
                }
            }
            // return state.agentes = dataAgente
        },
        cambioEstadoAgente(state,dataAgente) {
            console.log('cambioEstadoAgente',dataAgente)
            console.log('stateAgente', state.agentes)
            const existe = state.agentes.findIndex(mems => parseInt(mems.id) === parseInt(dataAgente.userId))
            if(existe !== -1){
                state.agentes[existe].estado = dataAgente.estado
                state.agentes[existe].abrev = dataAgente.abrev
            }
        },
        logoutAgente(state,agenteId){
            const existe = state.agentes.findIndex(age => parseInt(age.id) === parseInt(agenteId))
            if(existe !== -1){
                state.agentes.splice(existe,1)
            }
        },
        SET_AGENTES(state, agentes) {
            state.agentesDisp = agentes
        }
    }
}